<template>
  <div v-if="hasTags">
    <v-chip
      v-for="tag in tags"
      data-private
      class="mb-1 mr-1"
      outlined
      small
      :key="tag._id"
    >
      {{ tag.name }}
    </v-chip>
  </div>
  <div v-else>
    <v-chip color="grey--text text--darken-1" outlined small>
      {{ $t('routines.findings_no_tags') }}
    </v-chip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import mixin from '@/mixins/mixin.vue'

export default {
  name: 'TagsChips',

  mixins: [mixin],

  props: {
    tags: {
      type: Array,
      required: false,
    },
  },

  computed: {
    ...mapGetters(['organizationId']),

    hasTags() {
      return this.tags.length
    },
  },
}
</script>
